import { Injectable } from '@angular/core';
import { Project } from './project.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface ProjectsState extends EntityState<Project> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'projects' })
export class ProjectsStore extends EntityStore<ProjectsState> {

  constructor() {
    super();
  }

}

